import { Database } from "../../constants/schema.js";
//#region src/utils/schema-graphql-parser/dataType.ts
var stringTypes = {
	[Database.MariaDB]: "VARCHAR(255)",
	[Database.MSSQL]: "varchar(255)",
	[Database.MySQL]: "VARCHAR(255)",
	[Database.Oracle]: "VARCHAR2(255)",
	[Database.PostgreSQL]: "varchar(255)",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "STRING",
	[Database.Snowflake]: "VARCHAR(255)"
};
var intTypes = {
	[Database.MariaDB]: "INT",
	[Database.MSSQL]: "int",
	[Database.MySQL]: "INT",
	[Database.Oracle]: "INTEGER",
	[Database.PostgreSQL]: "integer",
	[Database.SQLite]: "INTEGER",
	[Database.Databricks]: "INT",
	[Database.Snowflake]: "INT"
};
var smallintTypes = {
	[Database.MariaDB]: "SMALLINT",
	[Database.MSSQL]: "smallint",
	[Database.MySQL]: "SMALLINT",
	[Database.Oracle]: "SMALLINT",
	[Database.PostgreSQL]: "smallint",
	[Database.SQLite]: "SMALLINT",
	[Database.Databricks]: "SMALLINT",
	[Database.Snowflake]: "SMALLINT"
};
var bigintTypes = {
	[Database.MariaDB]: "BIGINT",
	[Database.MSSQL]: "bigint",
	[Database.MySQL]: "BIGINT",
	[Database.Oracle]: "NUMBER(19)",
	[Database.PostgreSQL]: "bigint",
	[Database.SQLite]: "BIGINT",
	[Database.Databricks]: "BIGINT",
	[Database.Snowflake]: "BIGINT"
};
var floatTypes = {
	[Database.MariaDB]: "DOUBLE",
	[Database.MSSQL]: "float",
	[Database.MySQL]: "DOUBLE",
	[Database.Oracle]: "BINARY_DOUBLE",
	[Database.PostgreSQL]: "double precision",
	[Database.SQLite]: "REAL",
	[Database.Databricks]: "DOUBLE",
	[Database.Snowflake]: "FLOAT"
};
var decimalTypes = {
	[Database.MariaDB]: "DECIMAL(38,18)",
	[Database.MSSQL]: "decimal(38,18)",
	[Database.MySQL]: "DECIMAL(38,18)",
	[Database.Oracle]: "DECIMAL(38,18)",
	[Database.PostgreSQL]: "numeric",
	[Database.SQLite]: "DECIMAL",
	[Database.Databricks]: "DECIMAL(38,18)",
	[Database.Snowflake]: "DECIMAL(38,18)"
};
var booleanTypes = {
	[Database.MariaDB]: "BOOLEAN",
	[Database.MSSQL]: "bit",
	[Database.MySQL]: "BOOLEAN",
	[Database.Oracle]: "BOOLEAN",
	[Database.PostgreSQL]: "boolean",
	[Database.SQLite]: "BOOLEAN",
	[Database.Databricks]: "BOOLEAN",
	[Database.Snowflake]: "BOOLEAN"
};
var dateTypes = {
	[Database.MariaDB]: "DATE",
	[Database.MSSQL]: "date",
	[Database.MySQL]: "DATE",
	[Database.Oracle]: "DATE",
	[Database.PostgreSQL]: "date",
	[Database.SQLite]: "DATE",
	[Database.Databricks]: "DATE",
	[Database.Snowflake]: "DATE"
};
var timeTypes = {
	[Database.MariaDB]: "TIME",
	[Database.MSSQL]: "time",
	[Database.MySQL]: "TIME",
	[Database.Oracle]: "VARCHAR2(255)",
	[Database.PostgreSQL]: "time",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "STRING",
	[Database.Snowflake]: "TIME"
};
var dateTimeTypes = {
	[Database.MariaDB]: "DATETIME",
	[Database.MSSQL]: "datetime2",
	[Database.MySQL]: "DATETIME",
	[Database.Oracle]: "TIMESTAMP",
	[Database.PostgreSQL]: "timestamp",
	[Database.SQLite]: "DATETIME",
	[Database.Databricks]: "TIMESTAMP",
	[Database.Snowflake]: "TIMESTAMP_NTZ"
};
var dateTimeTzTypes = {
	[Database.MariaDB]: "TIMESTAMP",
	[Database.MSSQL]: "datetimeoffset",
	[Database.MySQL]: "TIMESTAMP",
	[Database.Oracle]: "TIMESTAMP WITH TIME ZONE",
	[Database.PostgreSQL]: "timestamptz",
	[Database.SQLite]: "DATETIME",
	[Database.Databricks]: "TIMESTAMP",
	[Database.Snowflake]: "TIMESTAMP_TZ"
};
var durationTypes = {
	[Database.MariaDB]: "VARCHAR(255)",
	[Database.MSSQL]: "varchar(255)",
	[Database.MySQL]: "VARCHAR(255)",
	[Database.Oracle]: "INTERVAL DAY TO SECOND",
	[Database.PostgreSQL]: "interval",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "INTERVAL DAY TO SECOND",
	[Database.Snowflake]: "VARCHAR(255)"
};
var jsonTypes = {
	[Database.MariaDB]: "JSON",
	[Database.MSSQL]: "json",
	[Database.MySQL]: "JSON",
	[Database.Oracle]: "JSON",
	[Database.PostgreSQL]: "jsonb",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "VARIANT",
	[Database.Snowflake]: "VARIANT"
};
var uuidTypes = {
	[Database.MariaDB]: "UUID",
	[Database.MSSQL]: "uniqueidentifier",
	[Database.MySQL]: "CHAR(36)",
	[Database.Oracle]: "VARCHAR2(36)",
	[Database.PostgreSQL]: "uuid",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "STRING",
	[Database.Snowflake]: "UUID"
};
var bytesTypes = {
	[Database.MariaDB]: "BLOB",
	[Database.MSSQL]: "varbinary(max)",
	[Database.MySQL]: "BLOB",
	[Database.Oracle]: "BLOB",
	[Database.PostgreSQL]: "bytea",
	[Database.SQLite]: "BLOB",
	[Database.Databricks]: "BINARY",
	[Database.Snowflake]: "BINARY"
};
var scalarTypes = {
	id: stringTypes,
	string: stringTypes,
	boolean: booleanTypes,
	int: intTypes,
	float: floatTypes,
	positiveint: intTypes,
	nonnegativeint: intTypes,
	unsignedint: intTypes,
	short: smallintTypes,
	smallint: smallintTypes,
	positivefloat: floatTypes,
	nonnegativefloat: floatTypes,
	bigint: bigintTypes,
	biginteger: bigintTypes,
	long: bigintTypes,
	int8: bigintTypes,
	safeint: bigintTypes,
	decimal: decimalTypes,
	bigdecimal: decimalTypes,
	numeric: decimalTypes,
	money: decimalTypes,
	datetime: dateTimeTypes,
	datetimeiso: dateTimeTypes,
	localdatetime: dateTimeTypes,
	timestamp: dateTimeTypes,
	timestamptz: dateTimeTzTypes,
	date: dateTypes,
	localdate: dateTypes,
	time: timeTypes,
	localtime: timeTypes,
	timetz: timeTypes,
	duration: durationTypes,
	iso8601duration: durationTypes,
	interval: durationTypes,
	json: jsonTypes,
	jsonb: jsonTypes,
	jsonobject: jsonTypes,
	uuid: uuidTypes,
	guid: uuidTypes,
	byte: bytesTypes,
	bytes: bytesTypes,
	bytea: bytesTypes,
	binary: bytesTypes,
	email: stringTypes,
	emailaddress: stringTypes,
	url: stringTypes,
	uri: stringTypes,
	void: stringTypes
};
function resolveDataType(named, database, model) {
	const fallback = stringTypes[database] ?? "";
	const enumMembers = getMembers(model.enums, named);
	if (enumMembers) return enumDataType(enumMembers, database) ?? fallback;
	if (getMembers(model.unions, named)) return fallback;
	return scalarTypes[named.toLowerCase()]?.[database] ?? fallback;
}
function enumCommentSuffix(named, model, database) {
	const enumMembers = getMembers(model.enums, named);
	if (enumMembers) return database !== void 0 && enumDataType(enumMembers, database) !== void 0 ? "" : membersSuffix(named, enumMembers);
	const unionMembers = getMembers(model.unions, named);
	return unionMembers ? membersSuffix(named, unionMembers) : "";
}
function enumDataType(members, database) {
	if (database !== Database.MySQL && database !== Database.MariaDB) return;
	return `ENUM(${members.map((member) => `'${member.replace(/'/g, "''")}'`).join(",")})`;
}
function membersSuffix(named, members) {
	return ` ${named}: ${members.join(" | ")}`;
}
function getMembers(source, named) {
	const members = source[named];
	return Array.isArray(members) && members.length ? members : void 0;
}
//#endregion
export { enumCommentSuffix, resolveDataType };
